export const CustomPalette = {
  primary: {
    main: "#06B2DA",
  },
  secondary: {
    main: "#818C9B",
  },
  warning: {
    main: "rgba(225, 153, 44, 1)",
    secondary: "rgba(225, 153, 44, 0.1)"
  },
  error: {
    main: "#EA6161",
  },
  success: {
    main: "#07C8B8",
    secondary: "rgb(7 200 184 / 22%)",
    dark: "rgb(4, 140, 128)",
  },
  info: {
    main: "#424C60",
  },
  black: {
    main: "rgba(0, 0, 0, 0.87)",
  },
  gray: {
    main: "rgba(129, 140, 155, 0.7)",
    light: "rgba(129, 140, 155, 0.2)"
  },
  background: {
    default: "#f5f5f5",
    paper: '#fff',
  },
  pink: {
    main: "#D758DF",
    secondary: "rgba(215, 88, 223, 0.1)"
  }
};
